import "core-js/modules/es.array.push.js";
export default {
  props: {
    category: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      sortPosts: [],
      postListOffsetTop: 0
    };
  },
  created() {
    this.setPosts();
  },
  mounted() {
    // this.postListOffsetTop = this.getElementToPageTop(this.$refs.postList) - 240
  },
  watch: {
    currentPage() {
      if (this.$route.query.p != this.currentPage) {
        // 此判断防止添加相同的路由信息（如浏览器回退时触发的）
        this.$router.push({
          query: {
            ...this.$route.query,
            p: this.currentPage
          }
        });
      }
      // setTimeout(() => {
      //   window.scrollTo({ top: this.postListOffsetTop }) // behavior: 'smooth'
      // },0)
      this.setPosts();
    },
    category() {
      this.setPosts();
    },
    tag() {
      this.setPosts();
    }
  },
  methods: {
    setPosts() {
      const currentPage = this.currentPage;
      const perPage = this.perPage;
      let posts = [];
      if (this.category) {
        posts = this.$groupPosts.categories[this.category];
      } else if (this.tag) {
        posts = this.$groupPosts.tags[this.tag];
      } else {
        posts = this.$sortPosts;
      }
      this.sortPosts = posts.slice((currentPage - 1) * perPage, currentPage * perPage);
    }
    // getElementToPageTop(el) {
    //   if(el && el.parentElement) {
    //     return this.getElementToPageTop(el.parentElement) + el.offsetTop
    //   }
    //   return el.offsetTop
    // }
  }
};